import { Box } from "@mui/material"
import StepsV2ContentCp from "../components/steps-v2-content.cp"

export default function StepsV2Page() {
  return (
    <Box sx={{ p: 3 }}>
      <StepsV2ContentCp />
    </Box>
  )
}
